import React from "react";
import Icon from "@/components/ui/Icon";
import {ipToColor} from "@/utils/colors";

const ProfileCircle = ({contact} : any) => {
  let clr = '#bbbbbb';
  if (contact?.geo?.ip) {
    let ipColor = ipToColor(contact.geo.ip);
    clr = ipColor ? ipColor : clr;
  }
  let style : any = {backgroundColor : `color-mix(in srgb, ${clr} 50%, white)`}

  return (
    <div className="block w-full h-full object-cover rounded-full bg-slate-400 flex items-center justify-center" style={style}>
      <Icon icon="heroicons-outline:user" width="50%" className="opacity-80" />
    </div>
  );
};

export default ProfileCircle;
